import type { CSSProperties } from 'react';

export const chromeStyles: Record<string, CSSProperties> = {
  fullscreenBtn: {
    pointerEvents: 'auto',
    width: 40,
    height: 40,
    fontSize: 18,
    background: 'rgba(0,0,0,0.75)',
    color: '#fff',
    border: '1px solid rgba(255,255,255,0.25)',
    borderRadius: 6,
    cursor: 'pointer',
    flexShrink: 0,
  },
  panelBack: {
    position: 'fixed',
    inset: 0,
    zIndex: 50,
    background: 'rgba(0,0,0,0.65)',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
    pointerEvents: 'auto',
  },
  panelFull: {
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    background: '#0a0e18',
    color: '#e8eaef',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  panelHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 20px',
    borderBottom: '1px solid #2c3348',
  },
  panelBody: { padding: '16px 20px', flex: 1, overflow: 'auto', fontSize: 14, lineHeight: 1.5 },
  closedBanner: {
    position: 'fixed',
    bottom: 24,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 7,
    pointerEvents: 'none',
    padding: '12px 20px',
    background: 'rgba(0,0,0,0.75)',
    color: '#fff',
    borderRadius: 8,
    maxWidth: 'min(92vw, 480px)',
    textAlign: 'center',
  },
  pickerList: { listStyle: 'none', margin: 0, padding: 0 },
  pickerItem: {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    padding: '12px 14px',
    marginBottom: 8,
    background: '#141824',
    color: '#fff',
    border: '1px solid #2c3348',
    borderRadius: 8,
    cursor: 'pointer',
  },
};
